/**
 * Матчер поиска по каталогам /bots (инструменты, тренды, галерея стилей).
 *
 * Клиентский и мгновенный: все данные вкладок уже загружены (секции
 * Популярных + StylesContext), бэкенд не нужен. Матч по словам: каждое
 * слово запроса должно встретиться в склейке полей (регистронезависимо,
 * ё=е) — «фон замена» найдёт «Замените фон на фото».
 */

export function normalizeSearch(s: string): string {
	return s.toLowerCase().replace(/ё/g, 'е').trim()
}

export function matchesQuery(query: string, ...fields: Array<string | undefined | null>): boolean {
	const q = normalizeSearch(query)
	if (!q) return true
	const hay = normalizeSearch(fields.filter(Boolean).join(' '))
	return q.split(/\s+/).every((w) => hay.includes(w))
}
